import { Link } from "react-router-dom";
import "../styles/coming-soon.css";

function ComingSoon({ name, tag = "Intellusion product" }) {
  return (
    <main className="ix-page cs-page">
      <section className="cs-wrap">
        <div className="ix-shell cs-inner">
          <span className="ix-eyebrow">{tag}</span>
          <h1 className="cs-title">{name}</h1>
          <p className="cs-soon">Coming soon</p>
          <p className="cs-note">
            We are building {name}. Check back shortly.
          </p>
          <Link to="/projects" className="ix-btn ix-btn--ghost cs-back">
            Back to products
          </Link>
        </div>
      </section>
    </main>
  );
}

export default ComingSoon;
